// By setting a default currency, we bypass an error that may happen when the currency is undefined;
// "Uncaught TypeError: Currency code is required with currency style."

interface PriceOptions {
  overrideFraction?: boolean;
  overrideLocales?: string;
}

interface TokenizedPrice {
  accumulator: string;
}

export const DEFAULT_CURRENCY = 'USD';

export const formatPrice = (
  currency: string | undefined | null,
  price: number | string | null | undefined,
  options?: PriceOptions | null | undefined
) => {
  const priceFormatter = new Intl.NumberFormat(options?.overrideLocales || 'en-US', {
    style: 'currency',
    currency: currency ? currency : DEFAULT_CURRENCY
  });

  if (options?.overrideFraction) {
    const localeSpecificTokens = priceFormatter.formatToParts(Number(price));

    /** manually build up price representation without fractional part */
    const extractPrice = (localeSpecificTokens: Intl.NumberFormatPart[]): TokenizedPrice => {
      if (!localeSpecificTokens.length) return { accumulator: '' };
      else {
        const tokenType = String(localeSpecificTokens[0]?.type);
        const { accumulator } = extractPrice(localeSpecificTokens.slice(1));
        switch (tokenType) {
          case 'integer':
          case 'group':
          case 'currency':
          case 'literal':
            return { accumulator: `${localeSpecificTokens[0]?.value}${accumulator}` };
        }
        return extractPrice(localeSpecificTokens.slice(1));
      }
    };

    const { accumulator } = extractPrice(localeSpecificTokens);
    return accumulator;
  }

  return priceFormatter.format(Number(price));
};
